var SERVER_URL = "https://localhost:44327/api/";
var QA = false;

if (process.env.REACT_APP_ENV === 'production')
{
    SERVER_URL =  "http://gestores.becasycredito.gob.mx:94/api/";
} 

if (process.env.REACT_APP_ENV === 'quality'){
    SERVER_URL =  "http://10.10.7.60:89/api/";
    QA = true;
}

export {SERVER_URL , QA};